@if (!errored()) {
  <app-positioning-card
    variant="full"
    [loading]="loading()"
    [completionPercent]="completionPercent()"
    [hints]="hints()"
    (hintAction)="navigate.emit($event)"
    (upgrade)="onUpgrade()" />
}
